module.exports = __webpack_public_path__ + "img/44.f10a1ad7.jpg";